module.exports = __webpack_public_path__ + "img/bananer-bg.6bb6cef3.png";